import styled from "styled-components";
import { RedBarBase } from "./RedBase";
export const RedPartitionBar = styled(RedBarBase) `
  height: ${props => props.height || "100%"};
  width: ${props => props.width || "2px"};
`;
